import { motion } from "framer-motion";
import { Reveal, EASE } from "./Reveal";

// Four-step method with a champagne line drawing across the steps.
const ProcessSteps = ({ steps, tone = "light" }) => {
  const ink = tone === "dark" ? "text-[#F4F0E8]" : "text-[#171717]";
  const sub = tone === "dark" ? "text-[#F4F0E8]/60" : "text-[#171717]/65";
  const border = tone === "dark" ? "border-[#F4F0E8]/12" : "border-[#171717]/12";

  return (
    <div className="relative" data-testid="process-steps">
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1.4, ease: EASE }}
        className="absolute -top-px left-0 hidden h-px w-full origin-left bg-[#C6A46A] md:block"
      />
      <div className="grid gap-10 md:grid-cols-4 md:gap-8">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className={`border-t pt-8 md:border-t-0 md:pt-10 ${border}`}>
              <span className="text-4xl font-light text-[#C6A46A]">{s.n}</span>
              <h3 className={`mt-4 text-lg font-light uppercase tracking-[0.14em] ${ink}`}>{s.t}</h3>
              <p className={`mt-4 text-sm leading-relaxed ${sub}`}>{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default ProcessSteps;
